module.exports = require("long");